<template>
  <modal v-bind="$attrs" v-on="$listeners" :center="true">
    <template v-slot:body>
      <div>
        <h4 id="leave-modal-title">
          {{ $t('assignments.modals_edit_timeline.title') }}
        </h4>
        <p id="leave-modal-desc">
          {{ $t('assignments.modals_edit_timeline.description') }}
        </p>
      </div>
    </template>
    <template v-slot:footer>
      <primary-button class="confirm-cancel" @click.native="$emit('closed')">
        {{ $t('assignments.modals_edit_timeline.button_text') }}
      </primary-button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/Modal'
import PrimaryButton from '@/components/common/buttons/PrimaryButton'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    Modal,
    PrimaryButton,
  },
  methods: {
    handleLeave() {
      this.$emit('closed')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

#leave-modal-title {
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  text-align: center;
  color: $black;
  margin:0 auto;
}

#leave-modal-desc {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: $black;
  margin:4px auto;

}

.elsa-button.continue,
.elsa-button.continue:hover {
    font-size: 16px;
    border-radius: 8px;
    padding-left: 16px;
    padding-right: 16px;
}

.elsa-button.cancel {
  padding: 0 16px;
  font-size: 16px;
}



::v-deep {
  .el-dialog.elsa-modal {
    .el-dialog__header,
    .el-dialog__body {
      //padding: 40px 40px 0 40px;
      // display: flex;
      background-color: white;
    }

    &.signup .el-dialog__body {
      padding: 0;
    }

    .el-dialog__header {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      min-height: 27.5px;
    }

    .el-dialog__body {
      border-top: none;
      & > *:not(p):not(.info) {
        padding-bottom: 6px;
        display: flex;
        flex-direction: column;
      }
    }

    .el-dialog__footer {
      padding: 0 20px 48px 20px;
      justify-content: center;
    }
  }
}
</style>
